import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { options, selectorVariableWidth, selectorNavigationNextButton, selectorNavigationPrevButton } from './shared/options';

document.addEventListener('DOMContentLoaded', () => {
  // Variable Width
  const config = {
    ...options,
    ...{
      slidesPerView: 'auto',
    },
  };

  const swiperVariableWidthMounts = document.querySelectorAll(selectorVariableWidth);
  swiperVariableWidthMounts.forEach((mount) => {
    const individualConfig = {};

    // Only add navigation module and config if controls exist
    const hasNavControls = mount.querySelector(selectorNavigationNextButton) &&
                           mount.querySelector(selectorNavigationPrevButton);
    if (hasNavControls) {
      individualConfig.modules = [Navigation];
      individualConfig.navigation = {
        nextEl: selectorNavigationNextButton,
        prevEl: selectorNavigationPrevButton,
      };
    }

    const customLoop = mount.getAttribute('data-custom-swiper-options-loop');
    if (customLoop !== null) {
      individualConfig.loop = customLoop === 'true';
    }

    const regularSpaceBetween = mount.getAttribute('data-custom-swiper-options-breakpoints-spaceBetween');
    if (regularSpaceBetween !== null) {
      individualConfig.spaceBetween = parseInt(regularSpaceBetween);
    }

    const desktopSpaceBetween = mount.getAttribute('data-custom-swiper-options-breakpoints-768-spaceBetween');
    if (desktopSpaceBetween !== null) {
      individualConfig.breakpoints = individualConfig.breakpoints || {};
      individualConfig.breakpoints[768] = individualConfig.breakpoints[768] || {};
      individualConfig.breakpoints[768].spaceBetween = parseInt(desktopSpaceBetween);
    }

    new Swiper(mount, { ...config, ...individualConfig });
  });
});
